import { Brain, ExternalLink, ChevronRight } from 'lucide-react';

export const QuizPromo = () => {
  return (
    <section className="py-12 md:py-16" data-testid="quiz-promo">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-gold/20 via-navy-light to-green/10 border border-white/10 p-8 md:p-12">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-green/10 rounded-full blur-3xl"></div>
          
          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8">
            {/* Icon */}
            <div className="w-20 h-20 rounded-2xl bg-gold/20 flex items-center justify-center flex-shrink-0">
              <Brain className="w-10 h-10 text-gold" />
            </div>
            
            {/* Content */}
            <div className="flex-1 text-center md:text-left">
              <h3 className="font-serif text-2xl md:text-3xl font-bold text-white mb-3">
                Nevíte, kde začít?
              </h3>
              <p className="text-gray-400 mb-6 max-w-xl">
                Vyplňte krátký finanční kvíz a zjistěte, v jaké kondici jsou vaše finance. 
                Za 2 minuty získáte personalizované doporučení.
              </p>
              <a
                href="https://kviz.pancung.cz/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="quiz-link"
                className="inline-flex items-center gap-2 btn-gold"
              >
                Spustit finanční kvíz
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
